import { DayGroup, MessageGroup } from '../types';

import { ItemGroup } from './ItemGroup';

export const DayGroupComponent = ({ group }: { group: DayGroup }) => {
  return (
    <div className="relative space-y-5">
      <div className="sticky left-0 right-0 top-0 z-[8] mx-auto max-w-lg text-center text-[10px] font-semibold text-muted-foreground">
        {group.date}
      </div>
      {group.messages.map((group: MessageGroup, groupIndex: number) => (
        <ItemGroup key={groupIndex} group={group} />
      ))}
    </div>
  );
};
